import { render, staticRenderFns } from "./AdditionFee.vue?vue&type=template&id=cac046c2"
import script from "./AdditionFee.js?vue&type=script&lang=js&external"
export * from "./AdditionFee.js?vue&type=script&lang=js&external"
import style0 from "./AdditionFee.vue?vue&type=style&index=0&id=cac046c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports